import { Flex } from 'antd'
import React from 'react'

// ===== WORK TYPE 헬퍼 함수 =====
const getWorkTypeInfo = (workType) => {
  switch (workType) {
    case 'ROUTINE':
      return {
        displayName: 'Routine',
        className: 'tracker-tag tracker-tag-routine',
      }
    case 'FAST':
      return {
        displayName: 'Fast',
        className: 'tracker-tag tracker-tag-fast',
      }
    case 'SCHEDULED':
      return {
        displayName: 'Scheduled',
        className: 'tracker-tag tracker-tag-scheduled',
      }
    default:
      return {
        displayName: workType || 'Work',
        className: 'tracker-tag tracker-tag-work',
      }
  }
}

const StandAloneAdminTrackerBoardList = ({ adminData, onWorkClick }) => {
  const pendingWorks = adminData?.pendingWorks || []
  const pendingCount = adminData?.pendingCount || 0
  const resolvedWorks24h = adminData?.resolvedWorks24h || []
  const resolvedCount = adminData?.resolvedCount || 0
  return (
    <div style={{ display: 'flex', gap: '16px', width: '100%', minWidth: 0 }}>
      {/* 왼쪽 패널: 운영 업무 이슈 발생 건 */}
      <div
        className="tracker-board-container variant-today"
        style={{ flex: 1, minWidth: 0 }}
      >
        {/* 헤더 영역 */}
        <div className="tracker-board-header">
          <div className="tracker-board-title">
            <span className="tracker-board-label">운영 업무 이슈 발생 건</span>
            <span className="tracker-board-count" style={{ color: '#F25A67' }}>
              {pendingCount?.toLocaleString()}
            </span>
          </div>
          {/* <span className="tracker-board-today-btn"></span> */}
        </div>
        <div className="tracker-board-body" style={{ paddingRight: 0 }}>
          <div className="tracker-board-list">
            {pendingWorks.length === 0 ? (
              <div className="tracker-board-empty">데이터가 없습니다</div>
            ) : (
              pendingWorks.map((work) => {
                const workInfo = getWorkTypeInfo(work.workType)

                return (
                  <div
                    className="tracker-board-item"
                    key={work.id}
                    role={onWorkClick ? 'button' : undefined}
                    style={onWorkClick ? { cursor: 'pointer' } : undefined}
                    onClick={() => onWorkClick?.(work)}
                  >
                    <div className="tracker-board-item-header">
                      {/* 왼쪽: 태그 + 제목 */}
                      <Flex gap={14} className="tracker-board-left">
                        <div className="tracker-board-tags">
                          <span className={workInfo.className}>
                            {workInfo.displayName}
                          </span>
                          {/* {work.hasProblem && (
                            <div className="tracker-board-problem-tag-wrapper">
                              <Tag
                                icon={
                                  <FireFilled style={{ color: '#F25A67' }} />
                                }
                                className="tracker-board-problem-tag"
                              >
                                이슈발생
                              </Tag>
                            </div>
                          )} */}
                        </div>

                        <div className="tracker-board-header-content">
                          <div className="tracker-board-title-row">
                            <span className="tracker-board-task-title">
                              {work.title}
                            </span>
                          </div>
                        </div>
                      </Flex>
                      {/* 오른쪽: 담당 부서 */}
                      {work.ownerPart && (
                        <div className="tracker-board-right">
                          <span
                            style={{
                              fontSize: '14px',
                              color: '#8C979D',
                              whiteSpace: 'nowrap',
                              fontWeight: 400,
                            }}
                          >
                            {'담당자'}
                          </span>
                          <div
                            style={{
                              width: '1px',
                              height: '12px',
                              backgroundColor: '#CED5DB',
                              margin: '0 2px',
                              flexShrink: 0,
                            }}
                          />
                          <span
                            style={{
                              fontSize: '14px',
                              color: '#383E44',
                              whiteSpace: 'nowrap',
                              fontWeight: 600,
                            }}
                          >
                            {work.ownerName}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )
              })
            )}
          </div>
        </div>
      </div>

      {/* 오른쪽 패널: 해결된 이슈 */}
      <div
        className="tracker-board-container variant-weekly"
        style={{ flex: 1, minWidth: 0 }}
      >
        {/* 헤더 영역 */}
        <div
          className="tracker-board-header"
          style={{ backgroundColor: 'transparent', opacity: 0.5 }}
        >
          <div className="tracker-board-title">
            <span className="tracker-board-label">해결된 이슈</span>
            <span className="tracker-board-count">
              {resolvedCount ? resolvedCount?.toLocaleString() : 0}
            </span>
          </div>
          <span
            className="tracker-board-today-btn"
            style={{
              border: 'none',
              backgroundColor: 'transparent',
            }}
          >
            24시간 이내에 해결된 이슈
          </span>
        </div>

        <div className="tracker-board-body" style={{ paddingRight: 0 }}>
          <div className="tracker-board-list" style={{ opacity: 0.5 }}>
            {resolvedWorks24h.length === 0 ? (
              <div className="tracker-board-empty">데이터가 없습니다</div>
            ) : (
              resolvedWorks24h.map((work) => {
                const workInfo = getWorkTypeInfo(work.workType)

                return (
                  <div className="tracker-board-item" key={work.id}>
                    <div className="tracker-board-item-header">
                      {/* 왼쪽: 태그 + 제목 */}
                      <Flex gap={14} className="tracker-board-left">
                        <div className="tracker-board-tags">
                          <span className={workInfo.className}>
                            {workInfo.displayName}
                          </span>
                          {/* {work.hasProblem && (
                            <div className="tracker-board-problem-tag-wrapper">
                              <Tag
                                icon={
                                  <FireFilled style={{ color: '#F25A67' }} />
                                }
                                className="tracker-board-problem-tag"
                              >
                                이슈발생
                              </Tag>
                            </div>
                          )} */}
                        </div>

                        <div className="tracker-board-header-content">
                          <div className="tracker-board-title-row">
                            <span className="tracker-board-task-title">
                              {work.title}
                            </span>
                          </div>
                        </div>
                      </Flex>

                      {/* 오른쪽: 담당 부서 */}
                      <div className="tracker-board-right">
                        <span
                          style={{
                            fontSize: '12px',
                            color: '#6d747a',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {work.ownerPart || ''}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              })
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default StandAloneAdminTrackerBoardList
